module.exports = __webpack_public_path__ + "static/media/Group_1597880740.24919137.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/Group_1597880740.png
// module id = 1211
// module chunks = 0